<div class="modal-wrapper">
  <form #f="ngForm" (submit)='onSubmit(f)' novalidate>
    <div class="modal-header">
      <div class="modal-header-content">
        <!-- TODO: controllare che nella creazione di una nuova esecuzione l'immagine si veda da qualsasi pagina si stia aprendo la modal -->
        <img
          *ngIf="!data?.entityName && data?.selector !== 'scenario'"
          class='ws-img'
          [src]="getIcon(data?.type, data?.toolName)"
          [alt]="data?.type"
        >
        <div class="d-flex flex-column">
          <h4 class="modal-title">{{data?.name}}</h4>
          <h6 class="modal-subtitle col-title" *ngIf='data?.subtitle'> in {{data?.subtitle}}</h6><p>  This is SFR2.0</p>
        </div>
      </div>
      <i class="ic-close icon-size-32" (click)="activeModal.dismiss('Cross click')"></i>
    </div>
    <div class="modal-body">
      <app-shared-with
        *ngIf='data?.selector === "share" && data?.sharedWith.length'
        big
        title='Already shared with:'
        [sharedWithList]="data?.sharedWith"
      ></app-shared-with>
      <div class="form-container">
          <div class="form-group" *ngIf=' data?.selector !== "share" '>
              <label for='name'
                     class="input-title"
                     [class.text-error]="f.controls?.name?.invalid && submitted">
                  {{ data?.entityName || data?.selector === 'execution' ? 'Name' : (data?.type | titlecase) + ' name'}}
              </label>
              <input name="name"
                     required
                     [(ngModel)]="name"
                     class="form-control"
                     type="text"
                     placeholder="{{ data?.entityName ? 'Insert name' : data?.type === 'execution' ? 'My new execution' : 'New ' + data?.type}}"
                     ngbAutofocus
                     [class.is-invalid]="f.controls?.name?.invalid && submitted">
              <small class="invalid-feedback text-error">Name is mandatory. Please fill the field!</small>
          </div>
          <div class="form-group" *ngIf=' data?.selector === "execution" '>
              <label for='companyName'
                     class="input-title"
                     [class.text-error]="f.controls?.companyName?.invalid && submitted">
                  Company name
              </label>
              <input name="companyName"
                     [(ngModel)]="companyName"
                     required
                     class="form-control"
                     type="text"
                     placeholder="Insert Company name"
                     [class.is-invalid]="f.controls?.companyName?.invalid && submitted">
              <small class="invalid-feedback text-error">Company name is mandatory. Please fill the field!</small>
          </div>
          <div class="form-group" *ngIf='data?.collaborators'>
              <!-- TODO: quando si apre la modal con i collaborators deve spuntare il messaggio di errore oppure si può fare il submit anche se l'utente non ha aggiunto collaboratori? -->
              <app-add-edit-collaborators [data]='data'
                                          (sendStatusToParent)='eventStatusFromChild($event)'>
              </app-add-edit-collaborators>
              <p class="subtitle-input">{{data?.subtitleInput}}</p>
          </div>
          <div class="form-group" *ngIf='data?.selector === "execution"'>
              <app-add-edit-destinations [source]='source'
                                         [didSubmit]='submitted'
                                         (sendDestinationToParent)='handleDestination($event)'>
              </app-add-edit-destinations>
              <span class="destination-helper" *ngIf='data?.selector === "execution"'>An execution must be in workspace › project › folder</span>
              <small class="text-error w-100 d-flex" *ngIf='validation'>Destination is mandatory. please choose one</small>
          </div>
          <div class="form-group" *ngIf="data?.selector === 'scenario'">
              <app-add-methodology [data]="data"
                                   [didSubmit]='submitted'
                                   (sendStatusToParent)='handleMethodology($event)'>
              </app-add-methodology>
              <small class="text-error w-100 d-flex" *ngIf='validation'>Methology is mandatory. please choose one</small>
          </div>
          <div *ngIf="data?.selector === 'execution'" class="custom-control custom-checkbox">
              <input type="checkbox"
                     class="custom-control-input"
                     id="enableclientupload_sfr_chb"
                     [(ngModel)]="enableclientupload_sfr"
                     [ngModelOptions]="{standalone: true}">
              <label class="custom-control-label" for="enableclientupload_sfr_chb">Require data uploading for the client</label>
          </div>
          <div class="form-group" *ngIf=' data?.selector !== "share" && enableclientupload_sfr'>
              <label for='clientemail_sfr'
                     class="input-title"
                     [class.text-error]="f.controls?.name?.invalid && submitted">
                  Client email address
              </label>
              <input name="clientemail_sfr"
                     required
                     [(ngModel)]="clientemail_sfr"
                     class="form-control"
                     type="text"
                     placeholder="clientname@email.domain"
                     [class.is-invalid]="f.controls?.clientemail_sfr?.invalid && submitted">
              <small class="invalid-feedback text-error">Please specify an email or uncheck client data uploading</small>
          </div>
      </div>
        
      <div *ngIf="data?.selector === 'execution'" class="custom-control custom-checkbox">
        <input
          type="checkbox"
          class="custom-control-input"
          id="privateMode"
          [(ngModel)]="isChecked"
          [ngModelOptions]="{standalone: true}"
        >
        <label class="custom-control-label" for="privateMode">Create this execution in private mode</label>
      </div>
    </div>
    <div class="modal-footer pt-5">
      <button type="button" class="btn btn-outline-dark" (click)="onDelete(f)">Cancel</button>
      <button class="btn btn-default ml-3" type='submit'>{{data?.buttonName}}</button>
    </div>
  </form>
</div>
